export const GENERAL_BADREQUEST = `@@ddw.herdnet.sandbox.hnadvice/GENERAL_BADREQUEST`;

export const GENERAL_NOACCESS = `@@ddw.herdnet.sandbox.hnadvice/GENERAL_NOACCESS`;

export const GENERAL_UNHANDLEDERROR = `@@ddw.herdnet.sandbox.hnadvice/GENERAL_UNHANDLEDERROR`;

export const GENERAL_ERROR = `@@ddw.herdnet.sandbox.hnadvice/GENERAL_ERROR`;
